import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import PeacockDataTable from '@/components/organisms/PeacockDataTable';
import {useSimpleDataTable} from '@/hooks/useSimpleDataTable';

const LEADERBOARD_PAGE_SIZE = 10;

const LeaderboardTable = ({data, period}) => {
  const {
    paginatedData,
    setPageIndex,
    setPageSize,
    setSortConfig,
    paginationConfig,
    selectionConfig,
    sortingConfig,
    filterConfig,
    toolbarConfig,
    displayConfig,
    pageSize
  } = useSimpleDataTable({
    data,
    pageSize: LEADERBOARD_PAGE_SIZE,
    noDataTitle: 'No leaderboard data available',
    noDataDescription:
      'No leaderboard data is available in this tab. Please upload a template if required'
  });

  // Reset page and rows-per-page when the leaderboard tab (period) changes
  React.useEffect(() => {
    setPageIndex(0);
    setPageSize(LEADERBOARD_PAGE_SIZE);
    setSortConfig(null);
  }, [period, setPageIndex, setPageSize, setSortConfig]);

  const columns = useMemo(
    () => [
      {columnKey: 'rank', header: 'RANK', enableSorting: true},
      {columnKey: 'points', header: 'POINTS', enableSorting: true}
    ],
    []
  );

  return (
    <div>
      <h4 className='mb-4 mt-8 text-[16px] font-bold leading-[22px] text-[#FFFFFF]'>
        {period} Leaderboard
      </h4>
      <PeacockDataTable
        columns={columns}
        records={paginatedData}
        pageSize={pageSize}
        totalRecords={data.length}
        paginationConfig={paginationConfig}
        selectionConfig={selectionConfig}
        sortingConfig={sortingConfig}
        filterConfig={filterConfig}
        toolbarConfig={toolbarConfig}
        displayConfig={displayConfig}
      />
    </div>
  );
};

LeaderboardTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      rank: PropTypes.number.isRequired,
      points: PropTypes.number.isRequired
    })
  ).isRequired,
  period: PropTypes.string.isRequired
};

export default React.memo(LeaderboardTable);
